import getApiUrl from "../utils/apiUrl";
import fetch from "../utils/mgFetch";

const getProductTypes = (
    token: string,
    backend: string, 
) => {
    return fetch(
        `${getApiUrl(backend)}producttypes`,
        {
            method: 'GET',
            headers: {
                Authorization: `Bearer ${token}`,
            },
        }
    );
};

export default getProductTypes